/**
 * Error codes that should be suppressed from error reporting (e.g., Sentry)
 * These are expected business logic errors that don't need to be tracked
 */
export const SUPPRESSED_ERROR_CODES: readonly string[] = [
  'EDC404', // Card not found / eligibility check failed
  // Add more error codes here as needed:
  // 'EDC401', // Unauthorized card access
  // 'EDC500', // Temporary service unavailable
];
